module.exports = __webpack_public_path__ + "static/media/2018_conf_Hacking_your_Tractor_with_Black_Market_Code.4882f9f0.png";